<template>
  <section class="plan-row-item__wrapper">
    <template v-if="isRegularPlanCard">
      <div
        :class="[
          'plan-row-item plan-row-item--long',
          isBestValue && 'plan-row-item--best-value plan-row-item--best-value-square',
        ]"
        @click="updateSelectedPlan(plan)"
      >
        <div
          v-if="plan.text"
          :class="['plan-row-item__header', isBestValue && 'plan-row-item__header--best-value']"
        >
          <div v-html="plan.text" class="plan-row-item__header-text"></div>
          <NotificationIcon
            v-if="plan.tooltip"
            class="plan-row-item__header-info-icon"
            v-tooltip="{
              content: `${plan.tooltip}`,
              placement: 'top',
              classes: ['tooltip__text-centered'],
            }"
          />
        </div>
        <div class="plan-row-item__radio-wrapper">
          <RadioButton :isSelected="isSelected" />
        </div>
        <div
          v-if="plan.subtitle.text"
          class="plan-row-item__subtitle"
          :style="{ color: plan.subtitle.color }"
        >
          {{ plan.subtitle.text }}
        </div>
        <div class="plan-row-item__title-container">
          <div class="plan-row-item__title">
            {{ normalizedPlanName }}
          </div>
          <div v-if="isMultipleCard" class="plan-row-item__toggle-container">
            <div
              v-for="(plan, index) in toggablePlans"
              :key="index"
              :class="[
                'plan-row-item__toggle-plan',
                plan.selected && 'plan-row-item__toggle-plan--selected',
              ]"
              @click="selectNestedPlan($event, plan)"
            >
              {{ plan.name }}
            </div>
          </div>
        </div>
        <PlanRowItemPrice :plan="plan" />
        <div
          :class="['plan-row-item__divider', `plan-row-item__divider--${plan.merchant_id}`]"
        ></div>
        <div class="plan-row-item__details">
          <PlanListItemDetails :plan="plan" />
          <div v-if="plan.infoTitle" class="plan-row-item__details-vouchers-container">
            <div class="plan-row-item__details-title">{{ plan.infoTitle }}</div>
            <div v-if="isFundamentalsAnnual" class="plan-row-item__details-badges-container">
              <img
                :src="require(`@/assets/icons/certs/ejpt-badge.png`)"
                alt="eJPT Voucher Badge"
                class="plan-row-item__details-voucher"
              />
              <PlusIcon class="plan-row-item__details-icon" />
              <img
                :src="require(`@/assets/icons/certs/icca-badge.png`)"
                alt="ICCA Voucher Badge"
                class="plan-row-item__details-voucher"
              />
            </div>
            <div
              v-if="isPremiumPlan"
              class="plan-row-item__details-badges-container plan-row-item__details-badges-container--off"
            >
              <img
                :src="require(`@/assets/images/vouchers/off_badge.png`)"
                alt="Off Badge"
                class="plan-row-item__details-voucher--one"
              />
            </div>
          </div>
        </div>
        <div class="plan-row-item__bottom-content" v-if="plan.link">
          <div class="plan-row-item__learn-more">
            <a target="_blank" :href="plan.link" class="plan-row-item__learn-more-link">
              <span>See What's Included</span>
              <ExternalLinkIcon class="plan-row-item__learn-more-icon" />
            </a>
          </div>
        </div>
        <div class="plan-row-item--best-value-square-bottom" v-if="isBestValue"></div>
      </div>
      <div
        class="plan-row-item--best-value-square-bottom--bf"
        v-if="isBestValue && isBlackFridayActive"
      >
        <div class="plan-row-item--best-value-square-bottom--bf--wrapper">
          <span> Premium Black Friday Savings Available </span>
          <router-link :to="{ name: 'black-friday' }" class="btn btn--primary btn--full-mobile">
            Shop now!
          </router-link>
        </div>
        <div><BfLogoNoBg /></div>
      </div>
    </template>
    <template v-if="isBoogoCard">
      <div
        class="plan-row-item plan-row-item--best-value plan-row-item--best-value-square plan-row-item--padding-40"
        @click="updateSelectedPlan(plan)"
      >
        <div class="plan-row-item--best-value-square-top"></div>
        <div class="plan-row-item__radio-wrapper">
          <RadioButton :isSelected="isSelected" />
        </div>
        <div class="plan-row-item__title plan-row-item__title--boogo">
          {{ normalizedPlanName }}
          <BooGooLogo class="plan-row-item__title-boogo-img" />
        </div>
        <PlanRowItemPrice :plan="plan" />
        <div class="plan-row-item__details">
          <PlanListItemDetails :plan="plan" />
        </div>
        <div class="plan-row-item__bottom-content plan-row-item__bottom-content--boogo-card">
          <div class="plan-row-item__not-included">*Skill Dive Not Included</div>
        </div>
        <div class="plan-row-item--best-value-square-bottom"></div>
      </div>
    </template>
    <template v-if="isNeonPromoCard">
      <div
        :class="[
          'plan-row-item',
          isBestValue &&
            'plan-row-item--best-value plan-row-item--best-value-square plan-row-item--best-value-neon',
        ]"
        @click="updateSelectedBundle(plan)"
      >
        <div v-if="isBestValue" class="plan-row-item__neon-lights-wrapper-upper">
          <div class="plan-row-item__neon-lights-wrapper-lower">
            <div class="plan-row-item__neon-lights"></div>
          </div>
        </div>
        <div class="plan-row-item--best-value-square-top-border" v-if="isBestValue"></div>
        <div class="plan-row-item__radio-wrapper">
          <RadioButton :isSelected="isSelected" />
        </div>
        <PlanRowItemNeonCardPrice :itemIndex="index" :plan="plan" />
        <PlanRowItemNeonCardTitle :plan="plan" />
        <div class="plan-row-item__details">
          <PlanListItemDetails :plan="plan" />
        </div>
        <div
          v-if="plan.textLeapYearPage"
          :class="[
            'plan-row-item__bottom-highlight',
            isBestValue && 'plan-row-item__bottom-highlight--best-value',
          ]"
        >
          <div v-html="plan.textLeapYearPage" class="plan-row-item__header-text"></div>
        </div>
        <div class="plan-row-item--best-value-square-bottom" v-if="isBestValue"></div>
      </div>
    </template>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { updateCart, priceDetailUpdates, routesRules } from '@/helpers/mixins'
import PlanListItemDetails from '@/components/plan-item-card/PlanListItemDetails.vue'
import PlanRowItemPrice from '@/components/plan-item-card/PlanRowItemPrice.vue'
import PlanRowItemNeonCardPrice from '@/components/plan-item-card/PlanRowItemNeonCardPrice.vue'
import PlanRowItemNeonCardTitle from '@/components/plan-item-card/PlanRowItemNeonCardTitle.vue'
import CONSTANTS from '@/constants'
import RadioButton from '@/components/shared/RadioButton.vue'
import NotificationIcon from '@/assets/icons/notification.svg'
import ExternalLinkIcon from '@/assets/icons/external_link_icon.svg'
import PlusIcon from '@/assets/icons/plus_white.svg'
import BooGooTitle from '@/assets/images/hero-section/boogo/boogo_card_title.svg'
import BfLogoNoBg from '@/assets/images/hero-section/black-friday/logo-nobg.svg'

const { PLANS, PREMIUM_PLANS, LEAP_YEAR_PROMO_PRODUCT_BUNDLES } = CONSTANTS
const { MONTHLY, ANNUAL } = PLANS

export default {
  name: 'PlanRowItem',
  mixins: [updateCart, priceDetailUpdates, routesRules],
  props: {
    plan: {
      type: Object,
      required: true,
    },
    currentPlans: {
      type: Array,
      required: false,
      default: () => [],
    },
    index: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      isBoogoCard: this.plan.merchant_id === PLANS.INE_PREMIUM_BOOGO_2Y,
    }
  },
  components: {
    PlanListItemDetails,
    PlanRowItemPrice,
    RadioButton,
    BooGooLogo: { ...BooGooTitle, name: 'BooGooTitle' },
    NotificationIcon: { ...NotificationIcon, name: 'NotificationIcon' },
    ExternalLinkIcon: { ...ExternalLinkIcon, name: 'ExternalLinkIcon' },
    PlusIcon: { ...PlusIcon, name: 'PlusIcon' },
    PlanRowItemNeonCardPrice,
    PlanRowItemNeonCardTitle,
    BfLogoNoBg,
  },
  computed: {
    ...mapState({
      isPremiumMonthlyPromoActive: state => state.app.isPremiumMonthlyPromoActive,
    }),
    ...mapGetters({
      isLeapYearPromoActive: 'app/isLeapYearPromoActive',
      isBusinessUser: 'business/isBusinessUser',
      isBlackFridayActive: 'app/isBlackFridayActive',
    }),
    isSelected() {
      if ([...Object.values(LEAP_YEAR_PROMO_PRODUCT_BUNDLES)].includes(this.plan.merchant_id)) {
        return this.plan.merchant_id === this.selectedBundle.merchant_id
      }
      return this.plan.merchant_id === this.selectedPlan.merchant_id
    },
    isBestValue() {
      return this.plan.isBestValue
    },
    isFundamentalsAnnual() {
      return this.plan.merchant_id === PLANS.ANNUAL
    },
    isPremiumPlan() {
      return this.plan.merchant_id === PLANS.PREMIUM
    },
    normalizedPlanName() {
      if (this.isBoogoCard) return 'Premium'
      switch (this.plan.merchant_id) {
        case PLANS.ANNUAL:
        case PLANS.MONTHLY:
          return 'Fundamentals'
        default:
          return this.plan.name
      }
    },
    isRegularPlanCard() {
      return ![PLANS.INE_PREMIUM_BOOGO_2Y].includes(this.plan.merchant_id) && !this.isNeonPromoCard
    },
    isNeonPromoCard() {
      return this.isLeapYearPromoActive && this.isLeapYearPromoPage
    },
    isMultipleCard() {
      return this.plan.selected !== undefined
    },
    toggablePlans() {
      const toggablePlans = [ANNUAL, MONTHLY]
      return toggablePlans.map(merchant_id => {
        const name = merchant_id.replace('fundamentals_', ' ').toUpperCase()
        return merchant_id === this.plan.merchant_id
          ? { name, merchant_id, selected: this.plan.selected }
          : { name, merchant_id, selected: !this.plan.selected }
      })
    },
    hasItemsImage() {
      return this.plan.merchant_id === ANNUAL
    },
  },
  methods: {
    isFundamentalPlan(plan) {
      return [ANNUAL, MONTHLY].includes(plan.merchant_id)
    },
    selectNestedPlan(event, plan) {
      event.stopPropagation()
      const selectedPlan = this.currentPlans.find(p => p.merchant_id === plan.merchant_id)
      if (
        selectedPlan &&
        this.isFundamentalPlan(selectedPlan) &&
        this.isFundamentalPlan(this.selectedPlan)
      ) {
        this.updateSelectedPlan(selectedPlan)
      }
      this.$emit('toggle-card', this.toggablePlans, plan.merchant_id)
    },
  },
}
</script>

<style lang="scss" scoped>
.plan-row-item {
  $border: 7;
  $border-unit: #{$border}px;
  background: var(--mid-gray-gradient);
  border-radius: 10px;
  padding: 20px;
  position: relative;
  cursor: pointer;
  transition: all 1s ease-out;
  width: 100%;
  &:hover {
    background: var(--mid-gray-translucid-gradient);
  }
  &:active {
    transition: all 0.5s ease-out;
    background: var(--charcoal-gradient-two);
  }

  @include tablet {
    padding: 20px 40px;
  }
  &--best-value {
    border-radius: 10px 10px 0 0;
    margin-bottom: 30px;
    padding: 20px 13px;

    @include mobile {
      border-radius: 10px;
      margin-bottom: unset;
    }

    @include tablet {
      padding: 20px 33px;
    }
  }
  &--best-value-square {
    position: relative;
    border-left: $border-unit solid var(--dark-orchid);
    border-right: $border-unit solid var(--majorelle-blue);
    border-radius: $border-unit;
    &-top {
      position: absolute;
      top: 0;
      left: -5px;
      height: $border-unit;
      width: calc(100% + $border-unit);
      background: var(--purple-gradient);
      border-radius: 47px;
    }
    &-top-border,
    &-bottom {
      position: absolute;
      bottom: 0;
      left: -5px;
      height: $border-unit;
      width: calc(100% + $border-unit);
      background: var(--purple-gradient);
      border-radius: 47px;
      &--bf {
        &--wrapper {
          width: 60%;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          gap: 10px;
        }
        border-radius: 0 0 7px 7px;
        background: var(--purple-gradient);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
        color: var(--white);
        margin-top: -40px;

        @include mobile {
          margin-top: -7px;
        }
      }
    }
    &-top-border {
      top: 0;
    }
  }
  &--long {
    padding-top: 55px;
  }
  &--padding-40 {
    padding: 40px;
  }
  &__wrapper {
    width: 100%;
    min-width: 342px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    @include mobile {
      min-width: 354px;
    }
    @include desktop {
      min-width: 542.5px;
    }
  }
  &__header {
    &-info-icon {
      width: 12px;
      margin-left: 5px;
    }
  }
  &__header,
  &__bottom-highlight {
    position: absolute;
    top: 0;
    left: 0px;
    height: 35px;
    width: 100%;
    background: var(--mid-gray-translucid-gradient-four);
    border-radius: 10px 10px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    &-text {
      color: var(--white);
      text-align: center;
      font-size: rem(14px);
      font-style: normal;
      font-weight: 500;
      display: flex;
      flex-flow: column;
      gap: 2px;
      @include tablet-ipad-air-and-mini-portrait {
        flex-flow: column;
      }
      @include tablet-ipad-pro {
        flex-flow: row;
      }
      @include desktop {
        flex-flow: row;
      }
    }
    &--best-value {
      background: var(--purple-gradient);
      left: -$border-unit;
      width: calc(100% + #{$border * 2}px);
      .plan-row-item__header-text {
        display: block;
      }
    }
  }
  &__bottom-highlight {
    height: 70px;
    bottom: 0;
    top: unset;
    border-radius: 0 0 10px 10px;
    &--best-value {
      background: var(--purple-gradient);
    }
  }
  &__title-container {
    display: flex;
    align-items: center;
    gap: 10px;
    @include desktop {
      height: unset;
    }
  }
  &__title {
    color: var(--white);
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;

    &--boogo {
      display: flex;
      align-items: center;
      column-gap: 5px;
    }
  }
  &__subtitle {
    color: var(--light-orange);
    font-size: rem(14px);
    line-height: rem(20px);
    font-weight: 500;
  }
  &__toggle-container {
    display: flex;
    border-radius: 20px;
    background: var(--tundora-gray);
  }
  &__toggle-plan {
    font-size: rem(12px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(14px);
    padding: 4px 10px;
    &--selected {
      background: var(--strong-light-green);
      color: var(--gray-3);
      border-radius: 20px;
    }
  }
  &__bottom-content {
    margin-top: 30px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    &--boogo-card {
      justify-content: flex-end;
    }
    &--bottom-highlight {
      height: 35px;
      margin-bottom: 70px;
    }
  }
  &__learn-more {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    white-space: nowrap;
    &-link {
      color: var(--purple-pale);
      font-size: rem(14px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(20px);
      text-decoration: none;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    &--justify-f-end {
      justify-content: flex-end;
    }
  }
  &__not-included {
    color: var(--light-blue-gray);
    font-size: rem(12px);
    font-style: italic;
    font-weight: 450;
    line-height: rem(14px);
    margin-bottom: 3px;
  }
  &__radio-wrapper {
    position: relative;
    left: 0;
    @include tablet {
      left: 20px;
    }
  }
  &__neon-lights {
    &-wrapper {
      &-upper {
        overflow: hidden;
        width: 100%;
        height: 300px;
        position: absolute;
        top: 0;
        left: 0;
      }
      &-lower {
        filter: blur(40px);
        position: absolute;
        background: linear-gradient(270deg, #196fc4 1%, #ff00e2 100%);
        background-repeat: no-repeat;
        top: 0;
        left: 0;
        width: 100%;
        height: 60%;
        border-radius: 0 0 50% 50%;
      }
    }
  }
  &__divider {
    border-bottom: 1px solid var(--mid-gray-translucid);
    margin-bottom: 30px;
    @include mobile {
      margin-bottom: 40px;
    }
    &--fundamentals_annual {
      width: calc(100% - 153px);
    }
    &--ine_premium {
      width: calc(100% - 170px);
    }
  }
  &__details {
    position: relative;
    &-vouchers-container {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      position: absolute;
      top: -42px;
      right: 0;
      @include mobile {
        top: -50px;
      }
    }
    &-title {
      color: var(--white);
      font-size: rem(14px);
      font-weight: 450;
      line-height: rem(20px);
    }
    &-badges-container {
      display: flex;
      margin-top: 30px;
      &--off {
        margin-top: 11px;
      }
    }
    &-voucher {
      width: 70px;
      &--one {
        width: 130px;
      }
    }
    &-icon {
      width: 16px;
      margin: 0 2px;
    }
  }
}

::v-deep .plan-row-item__header-text--fundamentals-annual {
  color: var(--purple-pale);
  font-weight: 700;
}
::v-deep .plan-row-item__bottom-highlight--you-save {
  font-size: rem(16px);
  font-style: normal;
  font-weight: 700;
  line-height: rem(23px);
}
</style>
